import { computed, provide, reactive } from "vue"

// flows
import loadConfigService from "./flows/loadConfig"
import loadCampaignService from "./flows/loadCampaign"
import loadUserService from "./flows/loadUser"

export const LandingFlow = function (options = {}, accountStore, localeStore) {

    /**
     * @type {import("@vue/reactivity").UnwrapRef<import("@/types/LandingFlow.d").LandingFlowStates>}
     */
    const states = reactive({
        mainAppName: options?.mainAppName ?? "",
        campaign: null,
        profile: null,
        blobWebLanding: null,
        blobUrl: "",
        query: null,
        appConfig: null,
        selectTier: {},
    })

    const transferPointStates = reactive({
        resultCheck: null,
        deductPoints: 0
    })

    const events = reactive({
        onReady: () => true,
        onError: () => true
    })

    const isPageReady = computed(() => {
        // check data is all load
        if (states.query != null && states.campaign != null && states.blobWebLanding != null && states.appConfig != null) {
            return true
        }
        return false
    })

    //#region methods

    const init = async function () {
        const configService = loadConfigService(states, localeStore)
        const campaignService = loadCampaignService(states)
        const userService = loadUserService(states)

        try {
            await configService.loadConfig()
            await campaignService.loadCampaignDetail()
            await userService.loadUserProfile()
            if (states.profile != null) {
                // set to account store
                accountStore.setters.setProfile(states.profile)
            }
            // if page ready then save cache to session storage
            states.query.saveCache()
            events.onReady(isPageReady)
        } catch (error) {
            events.onError(error)
        }
    }
    //#endregion

    provide("LandingStates", states)
    provide("TransferPointStates", transferPointStates)

    return {
        states,
        transferPointStates,
        isPageReady,
        events,
        init,
    }
}

export default LandingFlow
